import { SidebarLayout } from '@/layouts/sidebar/SidebarLayout';
import { PageWithLayout } from '@/pages/_app';
import { Helmet } from 'react-helmet-async';
import { CustomersContent } from '@/pageContents/customers/CustomersContent';

const Customers: PageWithLayout = () => {
    return (
        <>
            <Helmet>
                <title>Kunden | Starjack Backoffice</title>
            </Helmet>

            <CustomersContent />
        </>
    );
};

Customers.getLayout = (page) => <SidebarLayout>{page}</SidebarLayout>;
Customers.isProtected = true;

Customers.permissions = [];

export default Customers;
